import { useEffect, useState } from "react";
import { modeloCampanhasService, ModeloCampanha } from "../../../services/modeloCampanhasService";
import { message } from "antd";

export const useModeloCampanhas = () => {
  const [modeloCampanhas, setModeloCampanhas] = useState<ModeloCampanha[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [erro, setErro] = useState<string | null>(null);

  // 🔹 Carregar lista inicial de modelos
  const carregarModelos = async () => {
    setLoading(true);
    setErro(null);
    try {
      const data = await modeloCampanhasService.listarModeloCampanhasService();
      setModeloCampanhas(data || []);
    } catch (err: any) {
      console.error(err);
      setErro("Erro ao carregar modelos de campanhas");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarModelos();
  }, []);

  // 🔹 Cadastrar novo modelo
  const cadastrarModeloCampanha = async (dados: Partial<ModeloCampanha>): Promise<boolean> => {
    try {
      const novo = await modeloCampanhasService.cadastrarModeloCampanhaService(dados);
      if (novo) {
        setModeloCampanhas((prev) => [novo, ...prev]);
        message.success("Modelo de campanha criado com sucesso!");
        return true;
      }
      return false;
    } catch (error) {
      console.error("Erro ao cadastrar modelo:", error);
      message.error("Erro ao cadastrar modelo de campanha.");
      return false;
    }
  };

  // 🔹 Atualizar modelo existente
  const atualizarModeloCampanha = async (
    id: number,
    dados: Partial<ModeloCampanha>
  ): Promise<boolean> => {
    try {
      const atualizado = await modeloCampanhasService.atualizarModeloCampanhaService(id, dados);
      if (atualizado) {
        setModeloCampanhas((prev) =>
          prev.map((m) => (m.id === id ? { ...m, ...atualizado } : m))
        );
        message.success("Modelo de campanha atualizado com sucesso!");
        return true;
      }
      return false;
    } catch (error) {
      console.error("Erro ao atualizar modelo:", error);
      message.error("Erro ao atualizar modelo de campanha.");
      return false;
    }
  };

  // 🔹 Excluir modelo
  const excluirModeloCampanha = async (id: number) => {
    try {
      await modeloCampanhasService.excluirModeloCampanhaService(id);
      setModeloCampanhas((prev) => prev.filter((m) => m.id !== id));
      message.success("Modelo de campanha excluído com sucesso!");
    } catch (error) {
      console.error("Erro ao excluir modelo:", error);
      message.error("Erro ao excluir modelo de campanha.");
    }
  };

  // 🔹 Ativar ou desativar modelo
  const toggleAtivo = async (id: number, ativo: boolean) => {
    try {
      const atualizado = await modeloCampanhasService.atualizarStatusModeloCampanhaService(id, ativo);
      if (atualizado) {
        setModeloCampanhas((prev) =>
          prev.map((m) => (m.id === id ? { ...m, ativo } : m))
        );
        message.success(`Modelo ${ativo ? "ativado" : "desativado"} com sucesso!`);
      }
    } catch (error) {
      console.error("Erro ao alterar status:", error);
      message.error("Erro ao alterar status do modelo de campanha.");
    }
  };

  return {
    modeloCampanhas,
    loading,
    erro,
    cadastrarModeloCampanha,
    atualizarModeloCampanha,
    excluirModeloCampanha,
    toggleAtivo,
    carregarModelos,
  };
};
